module.exports = __webpack_public_path__ + "img/venture-logo.10d56630.png";